exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-status-link{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding-bottom:5px}.product-status-link .product-status-label{color:#aaa;margin-right:10px;width:auto}.product-status-link .status{-ms-flex-align:start;align-items:flex-start;display:-ms-flexbox;display:flex}.product-status-link .dot-icon-red,.product-status-link .dot-icon-yellow{-ms-flex:0 0 auto;flex:0 0 auto;margin:2px 5px 2px 0}.product-status-link .status button{font-weight:700}.cf .product-status-link .status button,.hitachi .product-status-link .status button{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/search/components/product-search-status-link/index.scss
// module id = 5144
// module chunks = 0